import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const token = localStorage.getItem('app_user');

  if (token) {
    return true;
  }

  return router.createUrlTree(['/sign-in']);
};
